const CLOCK_COLOUR_PATH =
  "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/";

const POSITIONS = {
  "Goal Shooter": "GS",
  "Goal Attack": "GA",
  "Wing Attack": "WA",
  Centre: "C",
  "Wing Defence": "WD",
  "Goal Defence": "GD",
  "Goal Keeper": "GK",
};

const POSITIONS_SORT = {
  "Goal Shooter": 7,
  "Goal Attack": 6,
  "Wing Attack": 5,
  Centre: 4,
  "Wing Defence": 3,
  "Goal Defence": 2,
  "Goal Keeper": 1,
};

export class TeamCrawl {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "TeamCrawl";
    this.scene = "TeamCrawl";
    this.data = [];
    this.page = 10010;
    this.animate_page = 10010;
  }

  async preview({ options }) {
    this.onAir = false;
    let lineup = [];
    let stats = [];

    if (options.game?.home_team._id === options.team._id) {
      lineup = options.game?.lineup?.home;
      stats = options.game?.home_player_stats;
      this.page = 10011;
      this.animate_page = 10010;
    } else if (options.game?.away_team._id === options.team._id) {
      lineup = options.game?.lineup?.away;
      stats = options.game?.away_player_stats;
      this.page = 10013;
      this.animate_page = 10012;
    }

    let header_xml = await this.getVizPage({ page: this.animate_page }).catch(
      (err) => {
        console.log(err);
      },
    );

    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });

    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "101"; // Number
      }).value = options.team?.short_name || "";

      let text = [];
      lineup
        ?.filter((p) => p.order <= 7)
        ?.sort((a, b) => {
          let stat_a = stats?.find((p) => p.squad_id === a?.squad?._id);
          let stat_b = stats?.find((p) => p.squad_id === b?.squad?._id);
          return (
            POSITIONS_SORT[stat_a?.position] - POSITIONS_SORT[stat_b?.position]
          );
        })
        .forEach((player, index) => {
          let stat = stats?.find((p) => p.squad_id === player?.squad?._id);

          text.push(
            (POSITIONS[stat?.position] ?? "") +
              "    " +
              (player?.squad?.player?.first_name || "") +
              " " +
              (player?.squad?.player?.last_name || ""),
          );
        });
      xml.payload.field.find((item) => {
        return item.attr.name === "102"; // Number
      }).value = text?.join("         ");
      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
      }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.animate_page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.animate_page });
  }
}
